export default __webpack_public_path__ + "static/media/Single.55c31701.jpg";